import { ErrorType } from "../hooks/errorReponse";

export type ErrorData = {
  code?: number;
  errorId?: string;
  email?: string;
  providerName?: string;
  providerLogo?: string;
};

export const GetErrorPageUrl = (data?: ErrorData): string => {
  if (!data) {
    return "/error?error_code=100";
  }

  switch (data.code) {
    case ErrorType.AnotherAccountGlobo:
      return `/error?error_code=101&email=${data.email}&error_id=${data.errorId}`;

    case ErrorType.ErrProviderWithoutResources:
      return `/error?error_code=102&error_id=${data.errorId}`;

    case ErrorType.UserWithoutPackage:
      return `/error?error_code=103&error_id=${data.errorId}`;

    case ErrorType.InvalidCredentials:
      return `/error?error_code=104&logo=${data.providerLogo}&name=${data.providerName}&error_id=${data.errorId}`;

    case ErrorType.ErrCommunicationWithProvider:
      return `/error?error_code=105&srcLogo=${data.providerLogo}&providerName=${data.providerName}&error_id=${data.errorId}`;

    case ErrorType.ProviderGenericError:
      return `/error?error_code=106&error_id=${data.errorId}`;
    default:
      return `/error?error_code=100&error_id=${data.errorId}`;
  }
};
